import { axiosHelper } from '@setvi/shared/services';
import { AxiosMethods, QuotesRFQApi } from '@setvi/shared/enums';

export enum QuotesQueryKey {
  GET_PREVIEW = 'GET_QUOTE_PDF_PREVIEW',
  GET_QUOTE = 'GET_QUOTE'
}

export const getQuotePreviewQuery = (id: string | number) => ({
  queryKey: [QuotesQueryKey.GET_PREVIEW, id],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesRFQApi.PreviewPDF.replace(':quoteId', id.toString()),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const getQuoteQuery = (id: string | number) => ({
  queryKey: [QuotesQueryKey.GET_QUOTE, id],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesRFQApi.Get.replace(':quoteId', id.toString()),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});
